import { useQuery } from '@tanstack/react-query';
import React, { useMemo, useState } from 'react';
import { Button, Col, Row, Table, Tag } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { api, Order, OrderListFilter } from '@restaurant/api';
import Filter from './components/Filter';
import { ORDER_STATUS_TEXT, ORDER_TYPE_TEXT } from '@restaurant/constants';
import { OrderType } from '@restaurant/types';
import { formatCurrency } from '@restaurant/utils';
import dayjs from 'dayjs';
import { Link } from 'react-router-dom';
import StatusTag from './components/StatusTag';

const PAGE_SIZE = 10;

const Items = ({ filter }: { filter: OrderListFilter | undefined }) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const columns = useMemo(
    () => [
      {
        dataIndex: 'orderNumber',
        title: 'No Order',
      },
      {
        dataIndex: 'orderType',
        title: 'Tipe',
        render: (col: Order['orderType']) => ORDER_TYPE_TEXT[col],
      },
      {
        dataIndex: 'tableNumber',
        title: 'Meja',
        render: (col: Order['tableNumber'], item: Order) => {
          if (item.orderType === OrderType.TakeAway) {
            return '-';
          }
          return `Meja ${col}`;
        },
      },
      {
        dataIndex: 'customerName',
        title: 'Nama Customer',
        render: (col: Order['customerName']) => (col ? col : '-'),
      },
      {
        dataIndex: 'status',
        title: 'Status',
        render: (col: Order['status']) => {
          return <StatusTag value={col} />;
        },
        align: 'center' as const,
      },
      {
        dataIndex: 'totalPrice',
        title: 'Total',
        align: 'right' as const,
        render: (col: Order['totalPrice']) => {
          return formatCurrency(col);
        },
      },
      {
        dataIndex: 'dateCreated',
        title: 'Created at',
        render: (col: Order['dateCreated']) => {
          return dayjs.unix(col).format('YYYY-MM-DD HH:mm');
        },
      },
      {
        title: 'Action',
        dataIndex: 'orderId',
        width: 120,
        render: (col: Order['orderId']) => {
          return (
            <Link to={`/restaurant/order/${col}`}>
              <Button type="primary">Detail</Button>
            </Link>
          );
        },
      },
    ],
    []
  );

  const { data, isLoading } = useQuery({
    queryKey: ['fetchOrderList', page, filter],
    queryFn: () => {
      return api.fetchOrderList({
        page,
        size: PAGE_SIZE,
        filter,
      });
    },
  });

  const items = data?.data ?? [];

  return (
    <Table
      columns={columns}
      loading={isLoading}
      dataSource={items}
      pagination={{
        total: data?.pagination.totalItems,
        pageSize: PAGE_SIZE,
        current: page,
        onChange: (page, pageSize) => {
          setPage(page);
          setPageSize(pageSize);
        },
      }}
    />
  );
};

const ListOrder = () => {
  const [filter, setFilter] = useState<OrderListFilter>();
  const tableKey = JSON.stringify(filter);

  return (
    <div className="p-6">
      <Row gutter={24}>
        <Col span={6}>
          <Filter setValue={setFilter} />
        </Col>
        <Col span={18}>
          <Items key={tableKey} filter={filter} />
        </Col>
      </Row>
    </div>
  );
};

export default ListOrder;
